import type { Tagged } from "@-/com.npmjs.type-fest";
import { createGate } from "@-/dev.improve.haniverse.lib.gate";
import { useTraditionalCharactersEnabled } from "@-/dev.improve.haniverse.lib.posthog";

export type HanziScriptToggleGate = Tagged<
  {
    /** Proof the `traditionalCharacters` flag is on for this learner. */
    traditionalCharactersEnabled: true;
  },
  "HanziScriptToggleGate"
>;

/**
 * The script toggle only exists while Traditional characters are offered (the
 * `traditionalCharacters` flag). `null` is that designed hidden state: the caller renders its own
 * "Han teaches Simplified" copy (or nothing) instead of the toggle.
 */
export function useHanziScriptToggleGate(): HanziScriptToggleGate | null {
  const traditionalCharactersEnabled = useTraditionalCharactersEnabled();
  return traditionalCharactersEnabled
    ? createGate<HanziScriptToggleGate>({ traditionalCharactersEnabled: true })
    : null;
}
